<template>
  <div>
    <div class="text-center">
      <h1>Indicateurs de la stratégie nationale</h1>
      <h3>(Secteur adulte)</h3>
    </div>
    <div class="highlight-main">
      <div v-for="(catData, cat) in sortedIndicators" :key="`indicator-category-${cat}`" class="highlight">
        <div :class="`result-container-${getCategoryStyle(cat)}`">
          <div class="highlight-title">{{getCategoryTitle(cat)}}</div>
          <div class="content">
            <div class="highlight-container">
              <div v-for="(indicator, id) in catData" :key="`indicator-${id}`" class="result-container">
                  <div>
                    <div class="result-value"><sui-indicator :value="indicator" @select="showChart">
                    </sui-indicator>
                    </div>
                  </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import indicator from '@/sui/components/results/indicator'
import results from '@/sui/data/results'

export default {
  name: 'indicators',

  data: function () {
    return {
    }
  },

  methods: {
    showChart: function (d) {
      this.$emit('select', d)
    },

    getCategoryTitle: function (t) {
      return results.getktTypeData(t).title
    },

    getCategoryStyle: function (t) {
      return results.getktTypeData(t).style
    },

    addIndToCategory: function (ind, result) {
      const category = ind.ktType

      if (category == null) {
        return null
      }
      const title = category
      const data = result[title]

      if (data == null) {
        result[title] = [ind]
      } else {
        data.push(ind)
      }
      return result
    }
  },

  computed: {
    sortedIndicators: function () {
      let result = {}
      const value = this.value
      if (value == null) {
        return null
      }

      for (let ind in value) {
        const indData = value[ind]
        result = this.addIndToCategory(indData, result)
      }
      return result
    }

  },

  props: {
    value: {
      type: Object,
      required: true
    }
  },

  components: {
    'sui-indicator': indicator
  }
}

</script>
<style scoped lang="less">
.highlight-title {
  font-size: 19px;
  max-width: 100rem!important;
  padding: 15px;
}

.highlight {
  padding: 0.5rem;
}

.highlight-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  margin-left: auto;
  margin-right: auto;

  .result-container {
    position: relative;
    padding: 0.3rem;
    padding-top: 0.1rem;
  }

  .result-value {
    position: relative;
    padding: 0.5rem;
    padding-bottom: .2rem;
  }
}
</style>
